import { useEffect, useState } from "react";
import GetIcon from "./Icon";

const ImagePreview = (image) => {
	const image_url = `${process.env.REACT_APP_API_URL}${image.image_path}`; // Replace with your image URL or state variable
	console.log(image.image_path);
	const hasImage = image?.image_path !== "";
	const [showPopup, setShowPopup] = useState(false);

	const handleButtonClick = () => {
		setShowPopup(true);
	};

	const handleClosePopup = () => {
		setShowPopup(false);
	};
	const handleEscapeKey = (event) => {
		if (event.key === "Escape") {
			setShowPopup(false); // Close the popup
		}
	};

	useEffect(() => {
		// Add event listener for keydown
		document.addEventListener("keydown", handleEscapeKey);

		// Cleanup event listener on component unmount
		return () => {
			document.removeEventListener("keydown", handleEscapeKey);
		};
	}, []);

	return (
		<>
			{hasImage && (
				<div
					className="w-auto mb-2 col-3"
					style={{
						border: "1px solid #dee2e6",
						padding: "0px 4px",
						backgroundColor: "#f8f6f6 ",
						borderRadius: "0.375rem",
					}}
				>
					<GetIcon
						iconName={"MdOutlineRemoveRedEye"}
						color="#000"
						action={handleButtonClick}
						size={18}
					/>
					{/* </button> */}

					{/* Popup for image preview */}
					{showPopup && (
						<div
							style={{
								position: "fixed",
								top: "0",
								left: "0",
								width: "100%",
								height: "100%",
								backgroundColor: "rgba(0, 0, 0, 0.5)",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								zIndex: "1000",
							}}
						>
							<div
								style={{
									backgroundColor: "white",
									padding: "20px",
									borderRadius: "10px",
									textAlign: "center",
									boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
								}}
							>
								<div className="d-flex justify-content-between gap-4">
									<h3 style={{ fontSize: "20px" }}>Image Preview</h3>
									<GetIcon
										iconName={"IoCloseSharp"}
										action={handleClosePopup}
										style={{
											padding: "1px 2px",
											border: "none",
											cursor: "pointer",
										}}
										color={"#000"}
										size={23}
									/>
								</div>
								<br />
								<img
									src={image_url}
									alt="Preview"
									style={{
										maxWidth: "100%",
										maxHeight: "300px",
										minHeight: "100px",
										minWidth: "100px",
										borderRadius: "5px",
										marginBottom: "10px",
										border: "1px solid #dee2e6",
									}}
								/>
							</div>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default ImagePreview;
